export default "__VITE_ASSET__CknAdzml__"